"use strict";import{tag as o}from"../custom-tag.js";export{setCustomTemplateLiteralTag}from"../custom-tag.js";export const ChevronDownIcon=({width:e=24,height:t=24,hidden:l=!1,title:r="Chevron Down"}={})=>o`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${e}"
    height="${t}"
    viewBox="0 0 20 20"
    aria-hidden=${l?"true":"false"}
    role="img"
    fill="currentColor"
    aria-label="${r}"
  >
    <path
      d="M10.67188,13.36133l5.33203-5.33203c.36914-.37109.36914-.97266,0-1.34375-.37109-.37012-.97266-.37012-1.34375,0l-4.66016,4.66016-4.66016-4.66016c-.37109-.37012-.97266-.37012-1.34375,0-.18457.18555-.27734.42871-.27734.67188s.09277.48633.27734.67188l5.33203,5.33203c.37109.37012.97266.37012,1.34375,0h.00001Z"
      fill="currentColor"
    />
  </svg>`;
//# sourceMappingURL=ChevronDown.js.map
